export default {
    title: 'Dataset Catalog',
    subtitle: 'Dataset Catalog',
    backTitle: 'Space Sky-ground Spectrum Cognitive Intelligence Dataset',
    connect: 'Contact Us',
    TAddress: 'Address',
    address: 'No. 29 Jiangjun Avenue, Jiangning District, Nanjing City',
    TEMail: 'Email',
    queryPlaceholder: 'Please enter a name for the dataset',
    SpectrumDataset: 'Spectrum Dataset',
    ChannelDataset: 'Channel Dataset',
    SignalDataset: 'Signal Dataset',
    dashboard:{
        datalistCnt: 'Datasets',
        visitorCnt: 'Visits',
        downloadCnt: 'Downloads',
    },
    table: {
        columns: {
            id: 'ID',
            name: 'Dataset',
            creator: 'Uploader',
            remark: 'Introduction',
            tags: 'Tags',
            size: 'Size',
            createdTime: 'Upload Time',
            downloadCnt: 'Download Count',
            action: 'Action',
            detailBtn: 'Detail'
        }
    },
    remark:{
        title: 'Dataset Description'
    }
}
